export default __webpack_public_path__ + "static/media/checkmark_checked.9e41069c.png";